import React, { useEffect } from 'react';

import { BrowserRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Dispatch } from './store';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import Router from './router';
import MagicProvider from './contexts/MagicContext';
import { ToastProvider } from './contexts/ToastContext';
import CONSTANTS from './contants';
import { msalConfig } from './authConfig';
import userStatusMonitor from './services/UserStatusMonitor';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  const dispatch = useDispatch<Dispatch>();

  const token = localStorage.getItem(CONSTANTS.token);

  useEffect(() => {
    if (token) {
      // Only fetch user data if not already available to prevent unnecessary API calls
      dispatch.auth.handleGetCurrentUser();
      
      // Start monitoring user status when token is present
      userStatusMonitor.startMonitoring();
    } else {
      // Stop monitoring when no token is present
      userStatusMonitor.stopMonitoring();
    }
  }, [token, dispatch.auth]);

  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <MagicProvider>
          <ToastProvider>
            <Router />
          </ToastProvider>
        </MagicProvider>
      </BrowserRouter>
    </MsalProvider>
  );
};

export default App;
